// import external dependencies
import 'jquery';
import 'slick-carousel';
import 'select2';
import 'pagepiling.js';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    console.log('DOMContentLoaded')
    jQuery('html').removeClass('show-landing');
    jQuery('html').addClass('show-anim');

  }, 1500);
}, false);



// WEBPACK FOOTER //
// ./scripts/main.js